import { useStorefrontScheduling } from "@/hooks/use-storefront-scheduling"
import { useSetAtom } from "jotai"
import { RESET } from "jotai/utils"
import { useEffect, useState } from "react"
import { Navigate } from "react-router-dom"
import { CheckoutSkeleton } from "./components/CheckoutSkeleton"
import { forgetCheckoutStep, resumableCheckoutStep } from "./lib/checkout-resume"
import { checkoutAtom } from "./state"

/**
 * Entry of the wizard. A customer who left it less than half an hour ago in
 * this tab (to add items, back to the bag) resumes at the step they left, with
 * what they filled in; the step guards then send them back to the earliest
 * step the new bag invalidates. Anyone else starts over: `timing` when the
 * merchant takes both modalities at this instant, `service` otherwise (§9.2
 * item 1), after the scheduling context is known.
 */
export function CheckoutEntry() {
  const scheduling = useStorefrontScheduling()
  const setCheckoutState = useSetAtom(checkoutAtom)
  const [resumeStep] = useState(() => resumableCheckoutStep())
  const [settled, setSettled] = useState(resumeStep !== null)

  useEffect(
    function settleStoredWizard() {
      forgetCheckoutStep()
      if (resumeStep) return
      setCheckoutState(RESET)
      setSettled(true)
    },
    [resumeStep, setCheckoutState],
  )

  if (resumeStep) return <Navigate to={resumeStep} replace />
  if (!scheduling.known || !settled) return <CheckoutSkeleton />
  return <Navigate to={scheduling.timingStepVisible ? "timing" : "service"} replace />
}
